import MultiSelectRange from './MultiSelectRange';
import DeliveryAndPickup from './DeliveryAndPickup';
import MultiSelectDefault from './MultiSelectDefault';
import CustomerTopRatedFacet from './CustomerTopRatedFacet';
import BrandFacet from './BrandFacet';
import ColorFacet from './ColorFacet';
import SizeFacet from './SizeFacet';

import MultiSelectRangeUtil from './util/MultiSelectRangeUtil';
import DeliveryAndPickupUtil from './util/DeliveryAndPickupUtil';
import MultiSelectDefaultUtil from './util/MultiSelectDefaultUtil';
import CustomerTopRatedFacetUtil from './util/CustomerTopRatedFacetUtil';
import BrandFacetUtil from './util/BrandFacetUtil';
import ColorFacetUtil from './util/ColorFacetUtil';
import SizeFacetUtil from './util/SizeFacetUtil';

// Map facet type or facet name to class name:
const facetTypesMapping = {
  default: 'MultiSelectDefault',
  MULTISELECTDEFAULT: 'MultiSelectDefault',
  MULTISELECTRANGE: 'MultiSelectRange',
  DELIVERY_AND_PICKUP: 'DeliveryAndPickup',
  MULTISELECTRATINGS: 'CustomerTopRatedFacet',
  MULTISELECTSCROLLBAR: 'BrandFacet',
  Price: 'MultiSelectRange',
  MULTISELECTFLYOUT: 'BrandFacet',
  MULTISELECTSWATCH: 'ColorFacet',
  MULTISELECTBUTTON: 'SizeFacet',
};

// list of all classes:
const facetTypes = {
  MultiSelectDefault,
  MultiSelectRange,
  DeliveryAndPickup,
  CustomerTopRatedFacet,
  BrandFacet,
  ColorFacet,
  SizeFacet,
};

// list of corresponding facet utils
const facetUtils = {
  MultiSelectRangeUtil,
  DeliveryAndPickupUtil,
  MultiSelectDefaultUtil,
  CustomerTopRatedFacetUtil,
  BrandFacetUtil,
  ColorFacetUtil,
  SizeFacetUtil,
};

/**
 * Determine a facet component name to render the given facet
 */
export const getFacetComponentName = (facetName, facetType, customTypes) => {
  const types = { ...facetTypesMapping, ...customTypes };

  // taking the first name wich is a key in facetTypesMapping:
  const componentName = [
    facetName,
    facetName.toUpperCase(),
    facetType,
    facetType?.toUpperCase(),
    customTypes.default,
    facetTypesMapping.default,
  ].find((name) => types[name]);

  return types[componentName || 'default'];
};

// returns class for the given facet
export const getFacetComponent = (...args) => facetTypes[getFacetComponentName(...args)];

// returns util class for the given facet
export const getFacetUtil = (...args) => facetUtils[`${getFacetComponentName(...args)}Util`];
